import { fetcher } from "helpers/fetcher";

import { TCreateCorpRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCorporationProfileInfo = async (corpId: string) => {
  return await fetcher<TCreateCorpRes, any>(
    ENDPOINT.CORPORATION.GET_CORPORATION_PROFILE_INFO,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.GET_CORPORATION_PROFILE_INFO.version,
        [API_HEADER.CORP_ID]: corpId,
        [API_HEADER.BLOCK_404]: true,
      },
    }
  );
};

export const querygetCorporationProfileInfo = async (corpId: string) => {
  return (await getCorporationProfileInfo(corpId)).data;
};

querygetCorporationProfileInfo._key = (corpId: string) => [
  ENDPOINT.CORPORATION.GET_CORPORATION_PROFILE_INFO.url,
  corpId,
];
